import { forwardRef, type InputHTMLAttributes, type ReactNode } from 'react';
import styles from './Input.module.css';

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  hint?: string;
  error?: string | null;
  startAdornment?: ReactNode;
  endAdornment?: ReactNode;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { label, hint, error, startAdornment, endAdornment, className = '', id, ...rest },
  ref,
) {
  const inputId = id ?? rest.name ?? `input_${Math.random().toString(36).slice(2, 9)}`;
  return (
    <label className={styles.wrap} htmlFor={inputId}>
      {label && <span className={styles.label}>{label}</span>}
      <span className={`${styles.field} ${error ? styles.fieldError : ''}`}>
        {startAdornment && <span className={styles.adornment}>{startAdornment}</span>}
        <input
          ref={ref}
          id={inputId}
          className={`${styles.input} ${className}`}
          aria-invalid={!!error}
          {...rest}
        />
        {endAdornment && <span className={styles.adornment}>{endAdornment}</span>}
      </span>
      {error ? (
        <span className={styles.error}>{error}</span>
      ) : hint ? (
        <span className={styles.hint}>{hint}</span>
      ) : null}
    </label>
  );
});
